<template>
  <div class="col-12">
    <div class="card mb-5 " style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">{{ $t('users.add.title') }}</h6>
          </div>
        </div>
      </div>
   
      <div class="card-body px-0 pb-2 mx-2 ">
        <div class="row mb-3 justify-content-center">
          <div class="col-md-8">
            <UserForm 
              ref="userForm"
              @submit="handleSubmit" 
              @cancel="handleCancel" 
              @validation-error="handleValidationError"
            />
            
            <!-- Action Buttons -->
            <div class="d-flex gap-3 mt-3">
              <button 
                type="button" 
                class="btn btn-primary btn-sm flex-grow-1"
                @click="submitForm"
                :disabled="isSubmitting"
              >
                <span v-if="isSubmitting">
                  <i class="fas fa-spinner fa-spin ms-2"></i>
                  {{ $t('users.add.adding') }}
                </span>
                <span v-else>
                  <i class="fas fa-save ms-2"></i>
                  {{ $t('users.add.addUser') }}
                </span>
              </button>
              <button 
                type="button" 
                class="btn btn-outline-secondary btn-sm flex-grow-1"
                @click="handleCancel"
                :disabled="isSubmitting"
              >
                <i class="fas fa-times ms-2"></i>
                {{ $t('users.add.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import UserForm from '@/components/features/user/forms/UserForm.vue';
import { useToast } from 'vue-toastification';

const toast = useToast();
const router = useRouter();
const store = useStore();
const userForm = ref(null);
const isSubmitting = ref(false);

const submitForm = () => {
  userForm.value.submit();
};

const handleSubmit = async (formData) => {
  isSubmitting.value = true;
  try {
    await store.dispatch('createUser', formData);
    
    toast.success("تمت إضافة المستخدم بنجاح");
    router.push('/users');
  } catch (error) {
    console.error('Error adding user:', error.response?.data);
    
    if (error.response?.status === 422) {
      const errors = error.response.data.errors || {};
      userForm.value.setServerErrors(errors);
      
      if (errors.email) {
        toast.error(errors.email[0]);
      } else if (errors.password) {
        toast.error(errors.password[0]);
      } else {
        toast.error("الرجاء تصحيح الأخطاء في النموذج");
      }
    } else {
      toast.error(error.response?.data?.message || "فشل في إضافة المستخدم");
    }
  } finally {
    isSubmitting.value = false;
  }
};

const handleValidationError = () => {
  toast.warning("الرجاء تعبئة جميع الحقول المطلوبة بشكل صحيح");
};

const handleCancel = () => {
  if (!isSubmitting.value) {
    router.push('/users');
  }
};
</script>
